"use strict";
// import { io } from "socket.io-client";
import { loadingSelectArray } from "../_redux/_constants";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { HubConnectionBuilder } from "@microsoft/signalr";

const URL =
    process.env.NODE_ENV === "production" ? undefined : "http://localhost:3000";

// const socket = io(URL, {
//     autoConnect: true,
// });

const createHubConnection = (userId) => {
    const hubUrl = process.env.SERVICES_GATEWAY_SIGNALR_BASE_URL;

    const connection = new HubConnectionBuilder()
        .withUrl(hubUrl + "?userId=" + userId)
        .withAutomaticReconnect()
        .build();

    return connection;
};

const isShowMainLoading = (subSetArray) => {
    return subSetArray.some((value) => {
        return loadingSelectArray.includes(value);
    });
};

const showCustomLoading = (subSetArray, pendingListArray) => {
    if (!Array.isArray(subSetArray)) {
        return false;
    }

    if (pendingListArray.length === 0) {
        return false;
    }

    return pendingListArray.some((value) => {
        return subSetArray.includes(value);
    });
};

const isErrorCodeExist = (errorCodes, customErrorList) => {
    if (customErrorList.length === 0) {
        return false;
    }

    return (
        customErrorList.filter((el) => {
            return errorCodes.some((f) => {
                return f == el.statusCode;
            });
        }).length > 0
    );
};

const selectCustomError = (errorCode, customErrorList) => {
    if (customErrorList.length === 0) {
        return false;
    }

    return customErrorList.filter((error) => error.statusCode == errorCode)[0];
};

const timeFormatUtcToLocal = (dateTime, isShowYear = true) => {
    const monthList = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sept",
        "Oct",
        "Nov",
        "Dec",
    ];

    let localTime = new Date(dateTime);

    if (isShowYear) {
        return (
            localTime.getDate() +
            " " +
            monthList[localTime.getMonth()] +
            " " +
            localTime.getFullYear()
        );
    }

    return localTime.getDate() + " " + monthList[localTime.getMonth()];
};

const checkDateIsBetweenTwoDays = (startDateTime, endDateTime) => {
    const currentDate = new Date();
    const startDate = new Date(startDateTime);
    const endDate = new Date(endDateTime);

    if (startDate < currentDate && currentDate < endDate) {
        return true;
    }

    return false;
};

const dateDiffWithToday = (startDate) => {
    const minute = 1000 * 60;
    const hour = minute * 60;
    const day = hour * 24;
    const year = day * 365;

    const date = new Date(startDate);
    const today = new Date();

    let startDateDiff = Math.round(date.getTime() / day);
    let todayDiff = Math.round(today.getTime() / day);

    return startDateDiff - todayDiff;
};

const checkDaysEquals = (date) => {
    const minute = 1000 * 60;
    const hour = minute * 60;
    const day = hour * 24;

    const dateTest = new Date(date);
    const dateToday = new Date();

    return (
        Math.round(dateTest.getTime() / day) ===
        Math.round(dateToday.getTime() / day)
    );
};

const kFormatter = (num) => {
    return Math.abs(num) > 999
        ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
        : Math.sign(num) * Math.abs(num);
};

const toHoursAndMinutes = (totalMinutes) => {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    if (hours > 0) {
        return hours + "h " + minutes + " min(s)";
    }

    return minutes + " min(s)";
};

const getFingerPrint = async () => {
    const fpPromise = FingerprintJS.load();
    const fp = await fpPromise;
    const result = await fp.get();

    // This is the visitor identifier:
    return result.visitorId;
};

function base64toBinary(base64String, filename, mimeType) {
    // Decode the Base64 string into binary data

    // Define the prefix for PNG images and remove it if present
    const prefix = "data:image/png;base64,";
    if (base64String.startsWith(prefix)) {
        base64String = base64String.substring(prefix.length);
    }

    // Decode the Base64 string into binary data
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);

    // Convert the binary string to an array of bytes
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    // Create a Uint8Array from the byte numbers
    const byteArray = new Uint8Array(byteNumbers);

    // Create a Blob from the byte array
    const blob = new Blob([byteArray], { type: mimeType });

    // Create a file from the Blob (if running in a browser environment)
    if (window && window.File) {
        const file = new File([blob], filename, { type: mimeType });
        return file;
    }

    // Return the Blob if running in a Node.js environment or File API is not available
    return blob;
}

export {
    isShowMainLoading,
    showCustomLoading,
    isErrorCodeExist,
    selectCustomError,
    timeFormatUtcToLocal,
    checkDateIsBetweenTwoDays,
    dateDiffWithToday,
    checkDaysEquals,
    kFormatter,
    toHoursAndMinutes,
    getFingerPrint,
    // socket,
    base64toBinary,
    // socket,
    createHubConnection,
};
